{
  "en": {
    "courseEnrollments": {
      "headers": {
        "title": "My Courses"
      },
      "tabs": {
        "active": "Active",
        "bookmarked": "Bookmarked",
        "inProgress": "In Progress",
        "completed": "Completed"
      },
      "empty": {
        "noEnrollments": "You have not enrolled in any courses yet.",
        "noInProgress": "You have no courses in progress.",
        "noBookmarked": "You haven't bookmarked any courses yet.",
        "noCompleted": "You haven't completed any courses yet.",
        "showAllCourses": "Show all available courses"
      }
    }
  }
}
